/* =========================================================================
   Bedrock — shopbedframes.com
   One file, no dependencies. Progressive enhancement only: every control
   here works as a plain link/form if JS never runs.
   ========================================================================= */
(function () {
  'use strict';

  var routes = window.__routes || {};
  var strings = window.__strings || {};

  /* ---------------------------------------------------------------------
     Utilities
     --------------------------------------------------------------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var scrollLocks = 0;
  function lockScroll() {
    scrollLocks++;
    document.body.classList.add('no-scroll');
  }
  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (scrollLocks === 0) document.body.classList.remove('no-scroll');
  }

  /* ---------------------------------------------------------------------
     Overlay panels (drawers + bottom sheets)
     --------------------------------------------------------------------- */
  var openPanel = null;

  function getOverlay() {
    var overlay = $('[data-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      overlay.setAttribute('data-overlay', '');
      document.body.appendChild(overlay);
      on(overlay, 'click', function () { closePanel(); });
    }
    return overlay;
  }

  function trapFocus(e) {
    if (!openPanel || e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, openPanel).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function showPanel(panel, trigger) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) closePanel();
    openPanel = panel;
    panel.__trigger = trigger || document.activeElement;
    panel.hidden = false;
    getOverlay().classList.add('is-open');
    // Read a layout property to flush the `hidden` removal before adding the
    // class, so the transform still transitions. rAF would be cleaner but
    // never fires in a backgrounded tab, leaving the panel stuck off-screen.
    void panel.offsetHeight;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    lockScroll();
    document.addEventListener('keydown', trapFocus);
    var focusTarget = panel.querySelector('[data-panel-focus]') || $$(FOCUSABLE, panel)[0];
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
  }

  function closePanel() {
    if (!openPanel) return;
    var panel = openPanel;
    openPanel = null;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    getOverlay().classList.remove('is-open');
    unlockScroll();
    document.removeEventListener('keydown', trapFocus);
    if (panel.__trigger && document.contains(panel.__trigger)) panel.__trigger.focus();
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 260);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      var panel = document.getElementById(opener.getAttribute('data-panel-open'));
      if (panel) { e.preventDefault(); showPanel(panel, opener); }
      return;
    }
    if (e.target.closest('[data-panel-close]')) { e.preventDefault(); closePanel(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) closePanel();
  });

  /* ---------------------------------------------------------------------
     Quantity steppers
     --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = $('input', wrap);
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------
     Cart
     --------------------------------------------------------------------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function replaceCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var markup = sections[key];
      if (!markup) return;
      var parsed = new DOMParser().parseFromString(markup, 'text/html');
      $$('[data-cart-section="' + key + '"]').forEach(function (target) {
        var source = parsed.querySelector('[data-cart-section="' + key + '"]');
        if (source) target.innerHTML = source.innerHTML;
      });
    });
  }

  function refreshCart(sections) {
    replaceCartSections(sections);
    return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  }

  function cartSectionIds() {
    return $$('[data-cart-section]')
      .map(function (el) { return el.getAttribute('data-cart-section'); })
      .filter(function (v, i, a) { return a.indexOf(v) === i; })
      .join(',');
  }

  // Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-button]');
    var label = btn ? btn.querySelector('[data-add-label]') : null;
    var original = label ? label.textContent : '';
    var errorEl = form.querySelector('[data-form-error]');

    if (btn) { btn.setAttribute('aria-disabled', 'true'); }
    if (label) label.textContent = strings.adding || 'Adding…';
    if (errorEl) errorEl.hidden = true;

    var data = new FormData(form);
    var ids = cartSectionIds();
    if (ids) data.append('sections', ids);

    fetch(routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || strings.cart_error);
        return refreshCart(res.body.sections).then(function () {
          var drawer = document.getElementById('cart-drawer');
          if (drawer) showPanel(drawer, btn);
        });
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-disabled');
        if (label) label.textContent = original;
      });
  });

  // Line item quantity change / remove
  function changeLine(key, quantity, source) {
    if (source) source.setAttribute('aria-busy', 'true');
    var ids = cartSectionIds();
    return fetch(routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ids })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return refreshCart(cart.sections);
      })
      .catch(function () { window.location.href = routes.cart; });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute('data-cart-remove'), 0, remove);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(input.getAttribute('data-cart-qty'), qty, input);
  });

  /* ---------------------------------------------------------------------
     Product gallery
     --------------------------------------------------------------------- */
  function initGallery(root) {
    var stage = $('[data-gallery-stage]', root);
    if (!stage) return;
    var slides = $$('[data-gallery-slide]', stage);
    var dots = $$('[data-gallery-dot]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    var counter = $('[data-gallery-current]', root);
    if (!slides.length) return;

    function setActive(index) {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (counter) counter.textContent = index + 1;
    }

    // Track the visible slide on mobile without a scroll listener storm.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.55) {
            setActive(slides.indexOf(entry.target));
          }
        });
      }, { root: stage, threshold: [0.55] });
      slides.forEach(function (s) { io.observe(s); });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      }
      setActive(index);
    }

    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function (e) { e.preventDefault(); goTo(i); });
    });

    root.__goToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return; }
      }
    };

    // Desktop click-to-zoom
    var zoom = $('[data-zoom-dialog]');
    if (zoom && typeof zoom.showModal === 'function') {
      slides.forEach(function (slide) {
        on(slide, 'click', function () {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          var src = slide.getAttribute('data-zoom-src');
          var alt = slide.getAttribute('data-zoom-alt') || '';
          if (!src) return;
          var img = $('[data-zoom-image]', zoom);
          if (img) { img.src = src; img.alt = alt; }
          zoom.showModal();
        });
      });
      on(zoom, 'close', function () { unlockScroll(); });
      on(zoom, 'click', function (e) { if (e.target === zoom) zoom.close(); });
    }

    setActive(0);
  }

  /* ---------------------------------------------------------------------
     Variant picker — option-agnostic
     Reads whatever options the product has, in whatever shape, and matches
     on the ordered list of selected values. Never assumes a "Size" option.
     --------------------------------------------------------------------- */
  function initVariantPicker(root) {
    var dataEl = $('[data-variant-data]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var form = $('[data-product-form]', root);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var priceEl = $('[data-variant-price]', root);
    var addButton = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var stockEl = $('[data-variant-stock]', root);
    var skuEl = $('[data-variant-sku]', root);
    var dimsEl = $('[data-variant-dims]', root);
    var gallery = $('[data-gallery]', root);
    var stickyPrice = $('[data-sticky-price]');
    var stickyMeta = $('[data-sticky-meta]');

    function selectedValues() {
      return $$('[data-option-index]', root)
        .filter(function (el) { return el.checked || el.tagName === 'SELECT'; })
        .sort(function (a, b) {
          return a.getAttribute('data-option-index') - b.getAttribute('data-option-index');
        })
        .map(function (el) { return el.value; });
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.length !== values.length) continue;
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // Grey out combinations that don't exist at all.
    function refreshAvailability(values) {
      $$('[data-option-index]', root).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var probe = values.slice();
        probe[idx] = input.value;
        var exists = variants.some(function (v) {
          for (var k = 0; k <= idx; k++) { if (v.options[k] !== probe[k]) return false; }
          return true;
        });
        var inStock = variants.some(function (v) {
          if (v.options[idx] !== input.value) return false;
          return v.available;
        });
        var wrap = input.closest('.variant-option');
        if (wrap) wrap.classList.toggle('variant-option--unavailable', !exists || !inStock);
      });
    }

    function render(variant) {
      if (idInput) idInput.value = variant ? variant.id : '';

      if (priceEl) {
        priceEl.innerHTML = variant ? variant.price_html : '';
      }
      if (stickyPrice && variant) stickyPrice.innerHTML = variant.price_html;
      if (stickyMeta && variant) stickyMeta.textContent = variant.title;

      if (addButton && addLabel) {
        if (!variant) {
          addButton.setAttribute('aria-disabled', 'true');
          addLabel.textContent = strings.unavailable || 'Unavailable';
        } else if (!variant.available) {
          addButton.setAttribute('aria-disabled', 'true');
          addLabel.textContent = strings.sold_out || 'Sold out';
        } else {
          addButton.removeAttribute('aria-disabled');
          addLabel.textContent = strings.add_to_cart || 'Add to cart';
        }
      }

      if (stockEl) {
        stockEl.className = 'product__stock';
        if (!variant || !variant.available) {
          stockEl.classList.add('product__stock--out');
          stockEl.innerHTML = variant ? (strings.out_of_stock || 'Out of stock') : '';
          stockEl.hidden = !variant;
        } else {
          stockEl.hidden = false;
          if (variant.inventory_managed && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
            stockEl.classList.add('product__stock--low');
            stockEl.innerHTML = (strings.low_stock || 'Only [count] left').replace('[count]', variant.inventory_quantity);
          } else {
            stockEl.innerHTML = strings.in_stock || 'In stock';
          }
        }
      }

      if (skuEl) {
        skuEl.textContent = variant && variant.sku ? variant.sku : '';
        skuEl.hidden = !(variant && variant.sku);
      }

      if (dimsEl) {
        dimsEl.textContent = variant && variant.dims ? variant.dims : '';
        dimsEl.hidden = !(variant && variant.dims);
      }

      // Update the selected-value label next to each option name
      $$('[data-option-index]', root).forEach(function (input) {
        if (!input.checked) return;
        var idx = input.getAttribute('data-option-index');
        var out = $('[data-option-value="' + idx + '"]', root);
        if (out) out.textContent = input.value;
      });

      if (variant && variant.featured_media_id && gallery && gallery.__goToMedia) {
        gallery.__goToMedia(variant.featured_media_id);
      }

      if (variant && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    on(root, 'change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var values = selectedValues();
      refreshAvailability(values);
      render(findVariant(values));
    });

    var initial = selectedValues();
    refreshAvailability(initial);
    render(findVariant(initial));
  }

  /* ---------------------------------------------------------------------
     Sticky add-to-cart bar
     --------------------------------------------------------------------- */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var sentinel = $('[data-sticky-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(sentinel);

    on(bar, 'click', function (e) {
      var btn = e.target.closest('[data-sticky-add]');
      if (!btn) return;
      e.preventDefault();
      var form = $('[data-product-form]');
      if (!form) return;
      // If options are still unchosen the main form is the source of truth.
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* ---------------------------------------------------------------------
     Collection facets — Section Rendering API, with full no-JS fallback
     --------------------------------------------------------------------- */
  function initFacets() {
    var forms = $$('[data-facet-form]');
    if (!forms.length) return;
    // The Section Rendering API keys off the section's id in the template,
    // not its type — read it from the markup rather than guessing.
    var host = $('[data-facet-section]');
    var sectionId = host && host.getAttribute('data-facet-section');
    if (!sectionId) return;

    function applyFrom(url, pushState) {
      var results = $('[data-facet-results]');
      if (results) results.setAttribute('aria-busy', 'true');

      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          // Match incoming panels to targets by index — the facet form is
          // rendered twice (desktop rail + mobile sheet) with distinct input
          // ids, so a first-match swap would duplicate ids across both.
          ['[data-facet-results]', '[data-facet-panel]', '[data-facet-meta]'].forEach(function (sel) {
            var incoming = parsed.querySelectorAll(sel);
            $$(sel).forEach(function (target, i) {
              if (incoming[i]) target.innerHTML = incoming[i].innerHTML;
            });
          });
          if (pushState) window.history.pushState({ url: url }, '', url);
          if (results) results.removeAttribute('aria-busy');
          var head = $('[data-collection-top]');
          if (head) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function () { window.location.href = url; });
    }

    function urlFromForm(form) {
      var params = new URLSearchParams(new FormData(form));
      // Strip empties so the URL stays readable and shareable.
      var clean = new URLSearchParams();
      params.forEach(function (value, key) { if (value !== '') clean.append(key, value); });
      var qs = clean.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    var submitDebounced = debounce(function (form) { applyFrom(urlFromForm(form), true); }, 350);

    forms.forEach(function (form) {
      on(form, 'change', function (e) {
        if (e.target.type === 'number' || e.target.type === 'text') submitDebounced(form);
        else applyFrom(urlFromForm(form), true);
      });
      on(form, 'submit', function (e) { e.preventDefault(); applyFrom(urlFromForm(form), true); });
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (!link) return;
      e.preventDefault();
      applyFrom(link.getAttribute('href'), true);
      if (openPanel) closePanel();
    });

    on(window, 'popstate', function () { applyFrom(window.location.href, false); });
  }

  /* ---------------------------------------------------------------------
     Predictive search
     --------------------------------------------------------------------- */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results || !routes.predictive_search) return;

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
      fetch(routes.predictive_search + '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var inner = parsed.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.hidden = !inner;
        })
        .catch(function () { results.hidden = true; });
    }, 250);

    on(input, 'input', run);
  }

  /* ---------------------------------------------------------------------
     Accordion groups that should open the first item on desktop only
     --------------------------------------------------------------------- */
  function initAccordions() {
    $$('[data-open-on-desktop]').forEach(function (el) {
      if (window.matchMedia('(min-width: 990px)').matches) el.setAttribute('open', '');
    });
  }

  /* ---------------------------------------------------------------------
     Boot
     --------------------------------------------------------------------- */
  function boot(scope) {
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-variant-picker]', scope).forEach(initVariantPicker);
    initStickyAtc();
    initFacets();
    initSearch();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var panel = e.target.querySelector('.drawer, .sheet');
    if (panel) showPanel(panel);
  });
})();
